import { parseMultiRange } from "./operations";

/** Which pages a watermark goes on: everything, a typed range, and/or "not the cover". */
export interface WatermarkPageChoice {
  /** Leave page 1 clean (a cover or title page). */
  skipFirst: boolean;
  /** Page numbers and ranges such as "2-5, 8". Empty means every page. */
  range: string;
}

export type WatermarkPagesResult = { pages: number[] } | { error: string };

/**
 * The 0-based pages to stamp, sorted and without repeats. An empty range means all pages; "skip first page"
 * is applied after the range, so "1-4" with skip first gives pages 2-4.
 */
export function watermarkTargetPages(choice: WatermarkPageChoice, pageCount: number): WatermarkPagesResult {
  let pages: number[];
  if (choice.range.trim()) {
    const parsed = parseMultiRange(choice.range, pageCount);
    if ("error" in parsed) return { error: parsed.error };
    pages = parsed.pages;
  } else {
    pages = Array.from({ length: pageCount }, (_, i) => i);
  }
  pages = Array.from(new Set(pages)).sort((a, b) => a - b);
  if (choice.skipFirst) pages = pages.filter((p) => p !== 0);
  if (pages.length === 0) {
    return { error: choice.skipFirst ? "No pages are left to watermark. Page 1 is skipped, so choose other pages." : "No pages chosen" };
  }
  return { pages };
}
